import { render, staticRenderFns } from "./contact-item.vue?vue&type=template&id=f947baa2&scoped=true"
import script from "./contact-item.vue?vue&type=script&lang=js"
export * from "./contact-item.vue?vue&type=script&lang=js"
import style0 from "./contact-item.vue?vue&type=style&index=0&id=f947baa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f947baa2",
  null
  
)

export default component.exports